import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IDNDList,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	PAYROLL_LIST_SCREEN_SLUG,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { IResponse, IServerError } from "../../models/common";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getDDLLabelByValue, sortDragDropContextDDLByText, useNavigateToLogout } from "../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { EmployeeService } from "../../services/EmployeeService";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { PayrollService } from "../../services/PayrollService";
import { PayrollYearToDateAddEmployeePanel } from "./Panels/PayrollYearToDateAddEmployeePanel";
import { PayrollYearToDateDataGrid } from "./PayrollYearToDateDataGrid";
import { PayrollYearToDateHeaderPanel } from "./Panels/PayrollYearToDateHeaderPanel";
import { PayrollYearToDateToolbar } from "./PayrollYearToDateToolbar";
import { YearToDateService } from "../../services/YearToDateService";
import { instanceOfIPayrollYearToDateAddEmployeeResponsePayload } from "../../common/instance-method";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";

export interface IPayrollYearToDate { }
const PAYROLL_LIST_QUERY_KEY = "payroll-year-to-date-list";
const YEARS_DDL_LIST_QUERY_KEY = "years-ddl";
const PAYROLL_YEAR_TO_DATE_ADD_EMPLOYEE_DATA_QUERY_KEY = "spayroll-year-to-date-add-employee-data-record";
// const ADD_EMPLOYEES = "payroll-add-employees";
// const REMOVE_EMPLOYEES = "payroll-remove-employees";

const firstPanelDraggableId = "firstList";
const secondPanelDraggableId = "secondList";


const useGetYearsDDL = (clientId: string, taxYear: number) =>
	useQuery({
		queryKey: [YEARS_DDL_LIST_QUERY_KEY, clientId, taxYear],
		queryFn: (data) => {
			return YearToDateService.getYearsDDL(clientId, taxYear);
		},
		refetchOnWindowFocus: false,
	});


const useGetYearToDatePayrollData = (
	isApiCalls: boolean,
	clientId: string,
	taxYear: number,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [
			PAYROLL_LIST_QUERY_KEY,
			isApiCalls,
			clientId,
			taxYear,
			params,
		],
		queryFn: (data) => {
			return YearToDateService.getYearToDatePayrollData(
				isApiCalls,
				clientId,
				taxYear,
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});


const useGetPayrollYearToDateAddEmployeePanels = (
	clientId: string,
	taxYear: number,
) =>
	useQuery({
		queryKey: [PAYROLL_YEAR_TO_DATE_ADD_EMPLOYEE_DATA_QUERY_KEY, clientId],
		queryFn: (data) => {
			return YearToDateService.getPayrollYearToDateAddEmployeePanel(clientId, taxYear);
		},
		refetchOnWindowFocus: false,
		enabled: false
	});

export const PayrollYearToDate: React.FC<IPayrollYearToDate> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [openDialog, setDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [loadingData, setIsLoading] = useState(false);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);
	const [payrollSetupTableData, setPayrollTableData] =
		useState([]);
	// const [remittanceFrequencyId, setRemittanceFrequencyId] = useState(undefined);
	const [selectedYear, setSelectedYear] = useState<any>(null)
	const [addEmployee, setAddEmployee] = useState(false);
	const [isApiCalls, setIsApiCalls] = useState(false);
	const [payrollTableDataState, setpayrollTableDataState] = useState<any>(undefined);

	const [firstList, setFirstList] = useState<IDNDList>({
		droppableId: "firstList",
		elements: [],
		testId: "firstList",
	});

	const [secondList, setSecondList] = useState<IDNDList>({
		droppableId: "secondList",
		elements: [],
		testId: "secondList",
	});

	const formMethods = useForm<any>({
		// resolver: yupResolver(ValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	// get call employee list assign/unassignn
	const {
		isLoading: isLoadingAssignedEmployees,
		data: assignedAddEmployeeResponsePayload,
		refetch: refetchAddEmployeePanels,
	} = useGetPayrollYearToDateAddEmployeePanels(clientId, selectedYear);

	// get call years ddl
	const { isPending: isPendingPayFrequencyDDL, data: yearsDDLItems } =
		useGetYearsDDL(clientId, taxYear);

	const { id } = useParams();
	const { isPending, data } = useGetYearToDatePayrollData(
		isApiCalls,
		clientId,
		selectedYear,
		queryParams,
		navigateToLogout
	);
	const payrollTableData: any | null = data;

	useEffect(() => {
		if (payrollTableData) {
			setpayrollTableDataState(payrollTableData)
		}
	}, [payrollTableData])

	const { isPending: isSubmitting, mutate: submitPayrollYearToDate } = useMutation({
		mutationFn: YearToDateService.createPayrollYearToDate,

		onSuccess: (res: IPayrollYearToDate | IServerError | IResponse | any) => {


			if (res && res.status === 201) {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				return Promise.all([
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_LIST_QUERY_KEY],
					}),
				]);
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});


	const onSubmit = (values: any) => {

		// alert("helo")
	};

	// const onSubmitButtonClickedHandler = () => {
	// 	const updatePayloadData =
	// 		payrollSetupTableData &&
	// 		payrollSetupTableData.map((item: any) => ({
	// 			...item,
	// 			clientId: clientId,
	// 		}));

	// 	submitPayrollYearToDate({ openBalancePayrollData: updatePayloadData })
	// };
	const onSubmitButtonClickedHandler = () => {
		if (selectedRowsValues.length) {

			const updatePayloadData =
				selectedRowsValues &&
				selectedRowsValues.map((item: any) => ({
					...item,
					clientId: clientId,
					customEarnings: Array.isArray(item.customEarnings)
						? item.customEarnings
						: item.customEarnings
							? Object.values(item.customEarnings)
							: [],
					customDeductions: Array.isArray(item.customDeductions)
						? item.customDeductions
						: item.customDeductions
							? Object.values(item.customDeductions)
							: [],
					customReimbursements: Array.isArray(item.customReimbursements)
						? item.customReimbursements
						: item.customReimbursements
							? Object.values(item.customReimbursements)
							: [],
				}));

			submitPayrollYearToDate({ openBalancePayrollData: updatePayloadData });
		} else {
			setSnackbarData({
				open: true,
				severity: "error",
				message: "Please select at least one row!"
			})
		}
	};

	const { isPending: isPendingAssignAndUnAssign, mutate: submitAddEmployeePayrollYearToDateFormData } = useMutation({
		mutationFn: YearToDateService.createPayrollYearToDateAddEmployeePanel,
		onSuccess: (res: IServerError | IResponse | null | any) => {
			if (res?.status === true) {
				setSnackbarData({
					open: true,
					message:
						"Client has been assigned to the Add employees successfully",
					severity: "success",
				});
				// return queryClient.invalidateQueries({
				// 	queryKey: [ADD_EMPLOYEES],
				// });
			} else if (res?.status === false) {
				setSnackbarData({
					open: true,
					message:
						"Client has been unassigned from the remove employees successfully",
					severity: "warning",
				});
				// return queryClient.invalidateQueries({
				// 	queryKey: [REMOVE_EMPLOYEES],
				// });
			}
		},
		onError: (err) => {
			setSnackbarData({
				open: true,
				message: "An error occurred, please try again",
				severity: "error",
			});
		},
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);


	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		// let selectedItemsIds = selectedItems && selectedItems.map((item: any) => item.id);
		setSelectedRowsValues(selectedItems);

		// if (selectedItems.length) {
		// 	return (
		// 		<></>
		// 	);
		// // }
		return (
			<></>
		);
	}, []);


	const upadtedPayrollItems = useMemo(() => {
		if (payrollTableDataState && payrollTableDataState.items) {
			return payrollTableDataState.items;
		}
	}, [payrollTableDataState]);

	const expandedLabels = ["Settings", "Year To Date"];
	const expandedPayrollYearToDateOrSetupItem = "Payroll Settings";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Year To Date" &&
				item.label === expandedPayrollYearToDateOrSetupItem
			) {
				isExpanded = true;
			}

			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				// path: item.label === expandedPayrollYearToDateOrSetupItem && `/settings/year-to-date/payroll/${id}`,
				path: item.label === expandedPayrollYearToDateOrSetupItem && `/settings/year-to-date/payroll`,
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: PAYROLL_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);


		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);



	useEffect(() => {
		if (
			assignedAddEmployeeResponsePayload &&
			instanceOfIPayrollYearToDateAddEmployeeResponsePayload(
				assignedAddEmployeeResponsePayload
			)
		) {
			let assigned: IDNDList = {
				droppableId: firstPanelDraggableId,
				elements: sortDragDropContextDDLByText(assignedAddEmployeeResponsePayload.assigned).map(
					(addEmployeesFlexField: any) => ({
						id: String(addEmployeesFlexField.id),
						text: String(addEmployeesFlexField.text),
						value: String(addEmployeesFlexField.value),
					})
				),
				testId: firstPanelDraggableId,
			};


			let unassigned: IDNDList = {
				droppableId: secondPanelDraggableId,
				elements: sortDragDropContextDDLByText(assignedAddEmployeeResponsePayload.unassigned).map(
					(removeEmployeesFlexField: any) => ({
						id: String(removeEmployeesFlexField.id),
						text: String(removeEmployeesFlexField.text),
						value: String(removeEmployeesFlexField.value),
					})
				),
				testId: secondPanelDraggableId,
			};

			setFirstList(assigned);
			setSecondList(unassigned);
		}
	}, [assignedAddEmployeeResponsePayload]);

	const onYearSelectionChangeHandler = (value: any) => {
		if (value.value) setSelectedYear(value.label)
		if (!value.value) setSelectedYear(undefined)

		// stop API
		setIsApiCalls(true);

		// clear UI data
		setpayrollTableDataState(undefined);

		// remove cache
		queryClient.removeQueries({
			queryKey: [PAYROLL_LIST_QUERY_KEY],
		});

		queryClient.removeQueries({
			queryKey: [PAYROLL_YEAR_TO_DATE_ADD_EMPLOYEE_DATA_QUERY_KEY],
		});
	}
	const onClickAddEmployeesHandler = (value: any) => {
		setAddEmployee(true);
		refetchAddEmployeePanels();
	}
	// const onCloseAddEmployeeHandler = () => {
	// 	setAddEmployee(false);
	// 	setIsApiCalls(true)
	// 	// const fetchData = async () => {
	// 	// 	setIsLoading(true);
	// 	// 	try {
	// 	// 		const response: any = await YearToDateService.getYearToDatePayrollData(
	// 	// 			true,
	// 	// 			clientId,
	// 	// 			taxYear,
	// 	// 			navigateToLogout
	// 	// 		);
	// 	// 	} catch {
	// 	// 	} finally {
	// 	// 		setIsLoading(false);
	// 	// 	}
	// 	// };
	// 	// fetchData();
	// };

	const onCloseAddEmployeeHandler = () => {
		setAddEmployee(false);
		// setIsApiCalls(false)
		queryClient.invalidateQueries({
			queryKey: [PAYROLL_LIST_QUERY_KEY],
		});
		setIsApiCalls(true);
	};

	const onDragEnd = (result: any, _provided: any) => {
		if (
			result.destination &&
			result.source.droppableId !== result.destination.droppableId
		) {
			if (result.source.droppableId === "firstList") {
				let sourceList = firstList;
				let destinationList = secondList;
				let movedItem = sourceList.elements.splice(result.source.index, 1)[0];
				destinationList.elements.splice(result.destination.index, 0, movedItem);
				setFirstList({
					...sourceList,
				});
				setSecondList({
					...destinationList,
				});
			} else {
				let sourceList = secondList;
				let destinationList = firstList;
				let movedItem = sourceList.elements.splice(result.source.index, 1)[0];
				destinationList.elements.splice(result.destination.index, 0, movedItem);
				setSecondList({
					...sourceList,
				});
				setFirstList({
					...destinationList,
				});
			}
		} else {
			if (!result.destination) return;
			if (result.source.droppableId === "firstList") {
				let sourceDestinationList = firstList;
				let sourceItem = sourceDestinationList.elements.splice(
					result.source.index,
					1
				)[0];
				sourceDestinationList.elements.splice(
					result.destination.index,
					0,
					sourceItem
				);
				setFirstList({
					...sourceDestinationList,
				});
			} else {
				let sourceDestinationList = secondList;
				let sourceItem = sourceDestinationList.elements.splice(
					result.source.index,
					1
				)[0];
				sourceDestinationList.elements.splice(
					result.destination.index,
					0,
					sourceItem
				);
				setSecondList({
					...sourceDestinationList,
				});
			}
		}

		if (result.destination.droppableId === "secondList") {
			let Payload = {
				// employeeId: result.draggableId,
				// flag: !true,
				flag: false,
				items: [
					{
						clientId: clientId,
						employeeId: result.draggableId,
						taxYear: selectedYear,
					},
				],
			};
			submitAddEmployeePayrollYearToDateFormData(Payload);
		} else {
			let Payload = {
				// employeeId: result.draggableId,
				flag: true,
				items: [
					{
						clientId: clientId,
						employeeId: result.draggableId,
						taxYear: selectedYear,
					},
				],
			};
			submitAddEmployeePayrollYearToDateFormData(Payload);
		}
	};

	const { isPending: isDeleting, mutate: deletePayrollYearToDateById } = useMutation({
		mutationFn: YearToDateService.delPayrollYearToDateById,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/settings/year-to-date/payroll`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [PAYROLL_LIST_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});


	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	// const deletePayrollYearToDateField = () => {
	// 	if (singleDelete) {
	// 		setSingleDelete(false);
	// 		let delPayload = {
	// 			payrollYearToDateById: payrollYearToDateById,
	// 			navigateToLogout: navigateToLogout,
	// 		};
	// 		deletePayrollYearToDateById(delPayload); // api not created yet change later
	// 		setDialogOpen(false);
	// 	}
	// };
	const deletePayrollYearToDateField = () => {
		if (singleDelete) {
			setSingleDelete(false);

			let delPayload = {
				clientId: clientId,
				taxYear: selectedYear,
				employeeIds: selectedRowsValues.map((x: any) => x.employeeId),
				navigateToLogout: navigateToLogout,
			};

			deletePayrollYearToDateById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		if (selectedRowsValues.length === 0) {
			setSnackbarData({
				open: true,
				message: "Please select at least one row!",
				severity: "error",
			});
		}
		else {
			setDialogOpen(true);
			setSingleDelete(true);
		}
	};

	return (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					// mt: "1.7rem"
				}}>
				<div
					style={{
						margin: "15px 0",
						fontSize: "1.5rem",
						fontWeight: "bold",
						fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
					}}
				>
					{"Payroll"}
				</div>
				<BackdropCircularProgress
					open={isPending || isSubmitting || isPendingPayFrequencyDDL || loadingData || isLoadingAssignedEmployees || isDeleting}
					testId="payroll-year-to-date"
				/>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={deletePayrollYearToDateField}
					cancelActionHandler={onCloseHandler}
					testId="payroll-year-to-date-confirmation-dialog"
				/>
				<FormProvider {...formMethods}>
					<form onSubmit={formMethods.handleSubmit(onSubmit)}>
						<PayrollYearToDateHeaderPanel
							yearsDDLItems={yearsDDLItems}
							onYearSelectionChangeHandler={onYearSelectionChangeHandler}
							selectedYear={selectedYear}
							onClickAddEmployeesHandler={onClickAddEmployeesHandler}
						/>
						{/* payrollTableData.items && payrollTableData.items.length > 0 && */}
						{selectedYear && payrollTableDataState && payrollTableDataState.items.length > 0 &&
							<PayrollYearToDateDataGrid
								columns=
								{
									payrollTableDataState?.headerColumns
										? payrollTableDataState.headerColumns.filter(
											(item: any) => item.field !== "id"
										)
										: []
								}
								// {payrollTableData ? payrollTableData?.headerColumns : []}
								rows={
									payrollTableDataState && upadtedPayrollItems
										? upadtedPayrollItems
										: []
									// payrollTableData?.items ?? []
								}
								showIndexColumn={true}
								// showChecboxColumn={payrollTableData && payrollTableData.rowSelection}
								showChecboxColumn={true}
								// showSettingColumn={true}
								// onRowEditClicked={onRowEditClicked}
								// onRowDeleteClicked={onRowDeleteClicked}
								onSnackbarMessageData={(value: any) => setSnackbarData(value)}
								totalRecords={
									payrollTableDataState && payrollTableDataState.total
										? payrollTableDataState.total
										: 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								selectionToolbar={selectionToolbar}
								selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
								searchFieldPlaceholder={"Search..."}
								pageTitle={"Payroll"}
								PayrollTableData={(data: any) =>
									setPayrollTableData(data)
								}
								// tableMargin={"0"}
								tableScrollHeight={true}

							/>}
						{payrollTableDataState && upadtedPayrollItems.length > 0 &&
							<PayrollYearToDateToolbar
								onSubmitButtonClickedHandler={onSubmitButtonClickedHandler}
								onDeleteClicked={onDeleteClicked}
							//  selectedYear={selectedYear}
							// onDeleteClicked={onDeleteClicked && onDeleteClicked}
							/>
						}
					</form>
				</FormProvider>
			</Grid>

			<EnhancedDialog
				dialogTitle="Employee(s)"
				key="Payroll Add Employees"
				testId="Payroll-Add-Employees"
				onCloseHandler={onCloseAddEmployeeHandler}
				open={addEmployee}
				dialogContent={
					<PayrollYearToDateAddEmployeePanel
						firstList={firstList}
						secondList={secondList}
						onDragEnd={onDragEnd}
						isLoadingAssignedEmployees={isLoadingAssignedEmployees}
						isPendingAssignAndUnAssign={isPendingAssignAndUnAssign}
					/>
				}
				showdividers={false}
				dialogAction={null}
			/>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}


			/>
		</>
	);
};
